import { render, staticRenderFns } from "./mobileBack.vue?vue&type=template&id=56714924&scoped=true"
import script from "./mobileBack.vue?vue&type=script&lang=js"
export * from "./mobileBack.vue?vue&type=script&lang=js"
import style0 from "./mobileBack.vue?vue&type=style&index=0&id=56714924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56714924",
  null
  
)

export default component.exports